import types from '../../constants';

const initialState = {
  input: '',
  selected: [],
};

const CommunicationBoxReducers = (state = initialState, action) => {
  switch (action.type) {
    case types.CBOX_CHANGE_INPUT:
      return {
        ...state,
        input: action.payload,
      };
    case types.CBOX_SELECT_USER:
      return {
        ...state,
        selected: state.selected.concat(action.payload),
      };
    case types.CBOX_DESELECT_USER:
      return {
        ...state,
        selected: state.selected.filter((user) => user !== action.payload),
      };
    case types.CBOX_DESELECT_ALL_USER:
      return {
        ...state,
        selected: []
      }
    case types.CBOX_CLEAR_INPUT:
      return {
        ...state,
        input: '',
      };
    default:
      return state;
  }
};

export default CommunicationBoxReducers;
